import React from 'react';

const FilterInput = ({ 
  label, 
  type = "text", 
  value, 
  onChange, 
  placeholder, 
  className = "",
  labelClassName = "text-xs",   
  error,   
  ...props 
}) => {
  const inputClasses = `w-full px-3 py-3 rounded-xl border ${
    error ? "border-red-500" : "border-grayish"
  } bg-grayish text-gray-500 focus:outline-none focus:ring-1 focus:ring-main1 font-cairo text-sm transition-all duration-200 calendar-main1 ${className}`;

  return (
    <div className="w-full">
      {/* الحاوية الرئيسية للحقل */}
      <div className="relative">
        {type === "textarea" ? (
          <textarea
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClasses}
            {...props}
          />
        ) : (
          <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClasses}
            {...props}
          />
        )}

        {label && (
          <label 
            className={`absolute right-2 top-0 bg-light px-1 transform -translate-y-1/2 pointer-events-none text-main1 font-medium ${labelClassName}`}
          >
            {label}
          </label>
        )}
      </div>

      {/* رسالة الخطأ خارج الحاوية */}
      {error && (
        <p className="text-red-500 text-xs mt-1 pr-2 text-right">{error}</p>
      )}
    </div>
  );
};

export default FilterInput;


































































































